import { FieldType } from '@pmp/api';

export const EXCHANGE_RATE_VALUE_LIST_NAMES: FieldType[] = [
  FieldType.SOURCE_CURRENCY,
  FieldType.TARGET_CURRENCY,
];